var vskoTooltip = angular.module('vskoTooltip', ['ui.bootstrap', 'ngSanitize'])

// tooltip element directive using ui-bootstrap tooltip

vskoTooltip.directive('vskoTooltipPopup', function() {
  return {
    restrict: 'A',
    scope: { contentExp: '&' },
    templateUrl: 'uib/template/tooltip/tooltip-html-popup.html'
  };
});

vskoTooltip.directive('vskoTooltip', ['$uibTooltip', function($uibTooltip) {
  return {
    restrict: 'A',
    link: function(scope, element, attributes) {

        var options = {useContentExp: true, tooltipEnable: true};

        if ('vskoTooltipOptions' in attributes) {
          var vskoTooltipOptions = attributes['vskoTooltipOptions'];

            if (vskoTooltipOptions) {
                options = angular.extend(options, scope.$eval(vskoTooltipOptions));

                // Unlike other options, the class name is retrieved from "tooltip-class" attribute
                if ('class' in options) {
                    attributes.tooltipClass = options.class;
                    delete options.class;
                }

                element.removeAttr('vsko-tooltip-options');
             }
        }

        var vskoTooltip = $uibTooltip('vskoTooltip', 'tooltip', 'mouseenter', options).compile(element, attributes);
        return vskoTooltip(scope, element, attributes);
    }
}}]);
